import type { AdminCrewReportRunningVesselsChartProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS } from "../../utils/admin-crew-report.constants";
import AdminCrewReportDeskBarChart from "./AdminCrewReportDeskBarChart";

const AdminCrewReportRunningVesselsChart = ({ statistics, view }: AdminCrewReportRunningVesselsChartProps) => {
  const viewLabels = ADMIN_CREW_REPORT_STATISTICS_VIEW_LABELS[view];

  return (
    <AdminCrewReportDeskBarChart
      title={viewLabels.runningVesselsTitle}
      categories={statistics.categories}
      emptyStateMessage={viewLabels.runningVesselsEmptyState}
      accessibleTotalText={`${statistics.totalVesselCount} vessels in total`}
      accessibleValueKind="vessel"
      cardDataTest="admin-crew-report-running-vessels-card"
      cardTestId="admin-crew-report-running-vessels-card"
      visualizationTestIdPrefix="admin-crew-report-running-vessels"
      className="md:col-start-2 md:row-start-3"
    />
  );
};

export default AdminCrewReportRunningVesselsChart;
